import { Button, Stack } from "react-bootstrap";
import { Col, Container, Row } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import {
  deactivateSponsor,
  deleteSponsor,
  getSponsor,
  updateSponsor,
} from "../../firebase/firebase.utils";
import { useEffect, useState } from "react";

import BusinessOverview from "../../components/business-overview/business-overview";
import CustomModal from "../../components/modal/customModal";
import Requests from "../../components/requests/requests";
import SocialMediaEdition from "../../components/social-media-edition/social-media-edition";
import SponsorExchange from "../../components/sponsor-exchange/sponsor-exchange";
import SponsorPromo from "../../components/sponsor-promo/sponsor-promo";
import Swal from "sweetalert2";
import darkLeftArrow from "./../../assests/darkLeftArrow.png";

const Sponsor = () => {
  const { id } = useParams();
  const [selectedBusiness, setSelectedBusiness] = useState(null);
  const [showSocialMediaEdition, setShowSocialMediaEdition] = useState(false);

  useEffect(() => {
    const getSingleSponsor = async () => {
      getSponsor(id).onSnapshot((business) =>
        setSelectedBusiness(business.data())
      );
    };

    getSingleSponsor();
  }, [id]);

  if (!selectedBusiness) {
    return;
  }

  const swalWithBootstrapButtons = Swal.mixin({
    customClass: {
      confirmButton: "btn btn-primary me-2",
      cancelButton: "btn btn-secondary",
      denyButton: "btn btn-danger me-2",
    },
    buttonsStyling: false,
  });

  const callOmitSponsor = () => {
    swalWithBootstrapButtons
      .fire({
        title: "Confirme su elección",
        showDenyButton: true,
        showCancelButton: true,
        cancelButtonText: "Cancelar",
        confirmButtonText: "Desactivar",
        confirmButtonColor: "#FAA60F",
        denyButtonText: "Eliminar",
      })
      .then((result) => {
        if (result.isConfirmed) {
          deactivateSponsor(id);
          updateSponsor(id, { isActive: false });
          Swal.fire("Sponsor desactivado", "", "success");
        } else if (result.isDenied) {
          deleteSponsor(id);
          Swal.fire("Sponsor eliminado", "", "success");
        }
      });
  };

  const callIncludeSponsor = () => {
    Swal.fire({
      title: "Confirme su elección",
      showDenyButton: true,
      showCancelButton: true,
      cancelButtonText: "Cancelar",
      confirmButtonText: "Activar",
      confirmButtonColor: "#FAA60F",
      denyButtonText: "Eliminar",
    }).then((result) => {
      if (result.isConfirmed) {
        updateSponsor(id, { isActive: true });
        Swal.fire("Sponsor activado", "", "success");
      } else if (result.isDenied) {
        deleteSponsor(id);
        Swal.fire("Sponsor eliminado", "", "success");
      }
    });
  };

  return (
    <Container>
      <Stack direction="horizontal" className="w-100 mb-4">
        <Link
          to="/sponsors"
          className="w-25 d-block link-dark text-decoration-none"
        >
          <h1 className="h5 mb-0">
            <span className="d-inline-block" style={{ width: "14px" }}>
              <img
                src={darkLeftArrow}
                alt="Black arrow icon"
                className="w-100"
              />
            </span>
            Atrás
          </h1>
        </Link>
        {selectedBusiness.isActive ? (
          <Button
            variant="link"
            className="text-dark ms-auto"
            onClick={callOmitSponsor}
          >
            Eliminar/Desactivar
          </Button>
        ) : (
          <Button
            variant="link"
            className="text-dark ms-auto"
            onClick={callIncludeSponsor}
          >
            Eliminar/Activar
          </Button>
        )}
      </Stack>
      <BusinessOverview
        business={selectedBusiness}
        id={id}
        openModal={setShowSocialMediaEdition}
      />
      <Row>
        <Col>
          <SponsorExchange business={selectedBusiness} id={id} />
        </Col>
        <Col>
          <SponsorPromo business={selectedBusiness} id={id} />
        </Col>
        <Col lg="6">
          <Requests business={selectedBusiness} id={id} />
        </Col>
      </Row>
      <CustomModal
        show={showSocialMediaEdition}
        handleClose={setShowSocialMediaEdition}
        modalTitle={() => "Editar Redes Sociales"}
      >
        <SocialMediaEdition
          sponsorId={id}
          business={selectedBusiness}
          onClose={setShowSocialMediaEdition}
        />
      </CustomModal>
    </Container>
  );
};
export default Sponsor;
